var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeoutLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.109,
    height: 98.621,
    viewBox: "0 0 202.109 98.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.27)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M501.706-416.534h26.3a1.052,1.052,0,0,1,1.055,1.047v0h0a1.055,1.055,0,0,1-1.055,1.052h-26.3a1.055,1.055,0,0,1-1.055-1.052h0A1.055,1.055,0,0,1,501.706-416.534Z",
    transform: "translate(-458.569 419.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M461.919-293.378h25.25a1.055,1.055,0,0,1,1.055,1.052h0a1.055,1.055,0,0,1-1.052,1.055H461.92a1.053,1.053,0,0,1-.744-.309,1.05,1.05,0,0,1-.309-.744h0a1.052,1.052,0,0,1,1.052-1.052Z",
    transform: "translate(-440.877 364.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M478.964-374.857h15.782a1.052,1.052,0,0,1,1.052,1.052h0a1.055,1.055,0,0,1-1.055,1.052H478.961a1.055,1.055,0,0,1-1.055-1.052h0a1.055,1.055,0,0,1,1.055-1.052Z",
    transform: "translate(-448.454 400.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M460.026-374.857h3.156a1.055,1.055,0,0,1,1.055,1.052h0a1.055,1.055,0,0,1-1.055,1.052h-3.156a1.055,1.055,0,0,1-1.055-1.052h0A1.055,1.055,0,0,1,460.026-374.857Z",
    transform: "translate(-440.034 400.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M456.233-335.07h17.888a1.055,1.055,0,0,1,1.055,1.055h0a1.055,1.055,0,0,1-1.055,1.052H456.234a1.051,1.051,0,0,1-1.055-1.048v0h0a1.054,1.054,0,0,1,.308-.744A1.05,1.05,0,0,1,456.233-335.07Z",
    transform: "translate(-438.348 382.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M425.923-335.07h7.364a1.052,1.052,0,0,1,1.055,1.048v0h0a1.052,1.052,0,0,1-1.052,1.052h-7.368a1.051,1.051,0,0,1-1.055-1.047v0h0a1.046,1.046,0,0,1,.308-.744,1.053,1.053,0,0,1,.744-.308Z",
    transform: "translate(-424.868 382.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M513.074-253.591h19.991a1.048,1.048,0,0,1,.745.308,1.048,1.048,0,0,1,.308.744h0a1.047,1.047,0,0,1-.308.744,1.054,1.054,0,0,1-.744.308H513.075a1.053,1.053,0,0,1-.744-.308,1.044,1.044,0,0,1-.308-.744h0a1.051,1.051,0,0,1,.309-.744,1.047,1.047,0,0,1,.744-.308Z",
    transform: "translate(-463.626 346.703)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    y2: 26.244,
    transform: "translate(168.325 51.92)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    y2: 1.569,
    transform: "translate(168.325 83.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    d: "M738.506-325.155l-15.652-26.868a3.784,3.784,0,0,0-5.173-1.368,3.781,3.781,0,0,0-1.365,1.364l-7.234,11.313",
    transform: "translate(-551.258 391.313)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    d: "M670.088-262.929a3.785,3.785,0,0,0,1.644,4.575,3.785,3.785,0,0,0,1.909.516h57a3.784,3.784,0,0,0,3.783-3.785,3.781,3.781,0,0,0-.514-1.9l-.808-1.387",
    transform: "translate(-533.814 351.738)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    fill: "none",
    cx: 48.921,
    cy: 48.921,
    r: 48.921,
    transform: "translate(60.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M698.975-359.838a47.846,47.846,0,0,1,2.332,14.806,47.65,47.65,0,0,1-9.115,28.109",
    transform: "translate(-543.748 393.951)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M622.819-343.4a47.8,47.8,0,0,1-38.75,19.758A47.867,47.867,0,0,1,536.2-371.506h0a47.867,47.867,0,0,1,47.867-47.867h0a47.768,47.768,0,0,1,17.123,3.153",
    transform: "translate(-474.379 420.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    fill: "none",
    d: "M632.118-370.676a48.922,48.922,0,0,1-48.893,47.247A48.921,48.921,0,0,1,534.3-372.349a48.921,48.921,0,0,1,48.921-48.921,48.921,48.921,0,0,1,48.921,48.921q0,.84-.028,1.673",
    transform: "translate(-473.535 421.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "#5CC7DB",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "3px",
    d: "M664.739-408.287a47.686,47.686,0,0,1,8.385,6.011",
    transform: "translate(-531.539 415.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#8896A3",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M631.617-374.347a47.8,47.8,0,0,1-15.16,40.769,47.867,47.867,0,0,1-67.634-2.845v0h0a47.866,47.866,0,0,1,2.846-67.634l0,0h0a47.776,47.776,0,0,1,14.74-9.266",
    transform: "translate(-474.375 417.738)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    fill: "none",
    cx: 48.921,
    cy: 48.921,
    r: 48.921,
    transform: "translate(61.064 0.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "#5CC7DB",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "3px",
    d: "M687.345-389.589q1.088,1.222,2.1,2.526",
    transform: "translate(-541.592 407.182)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5CC7DB",
    width: 2.221,
    height: 26.578,
    rx: 1.111,
    transform: "translate(107.464 23.319)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5CC7DB",
    width: 2.398,
    height: 36.288,
    rx: 1.199,
    transform: "translate(107.294 48.994) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    fill: "#8896A3",
    stroke: "#8896A3",
    d: "M771.582-286.962l4.448,7.7a.586.586,0,0,1-.205.8h0a.588.588,0,0,1-.8-.225l-4.448-7.7a.588.588,0,0,1,.2-.8h0a.588.588,0,0,1,.8.226Z",
    transform: "translate(-578.569 361.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    fill: "#8896A3",
    stroke: "#8896A3",
    d: "M766.333-296.2l.96,1.539a.564.564,0,0,1-.221.8h0a.663.663,0,0,1-.863-.225l-.96-1.539a.564.564,0,0,1,.221-.8h0A.663.663,0,0,1,766.333-296.2Z",
    transform: "translate(-576.197 365.787)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutLink);
export default __webpack_public_path__ + "static/media/timeout_link.8729d34b.svg";
export { ForwardRef as ReactComponent };